export type LegalWording = 'terms' | 'privacy' | 'legalNotice' | 'poweredBy';
